import { PrimaryButton, SecondaryButton } from '@library/components/buttons';
import { createContext, useContext } from 'react';
import type { CalendarContainerProps } from 'react-datepicker';
import { TimePicker } from '@library/components/datePicker/TimePicker';

export const CalendarContainerContext = createContext<{
  handleCancel?: () => void;
  handleSave?: () => void;
  saveDisabled?: boolean;
}>({
  handleCancel: undefined,
  handleSave: undefined,
  saveDisabled: false
});

export const CalendarContainer = ({ children }: CalendarContainerProps) => {
  const { handleCancel, handleSave, saveDisabled } = useContext(
    CalendarContainerContext
  );

  const showActionButtons = !!handleCancel && !!handleSave;

  return (
    <div className="!bg-soFresh-110 !border-soFresh-140 !text-soClean-140 font-heebo relative flex flex-col rounded-sm border p-3 text-sm">
      {children}

      <TimePicker />

      {showActionButtons && handleCancel && handleSave && (
        <div className="flex justify-end gap-2">
          <SecondaryButton
            handleOnClick={handleCancel}
            title="Cancel Date Change"
          >
            Cancel
          </SecondaryButton>

          <PrimaryButton
            disabled={saveDisabled}
            handleOnClick={handleSave}
            title="Save Date Change"
          >
            Save
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};
